export const CHALLENGE = '#dc2229';
export const IMPROVE = '#28b7b2';
export const STRENGTH = '#4375a4';
export const NOT_APPLICABLE = '#eeeeee';